import gql from 'graphql-tag';

export const CONTACT_US = gql`
  mutation Mytation($input: ContactUs) {
    contact_us(input: $input)
  }
`;

export const CONTACT_US_DEPARTMENTS = gql`
  query ContactUsDepartments {
    listContactUsDepartments {
      id
      name
    }
  }
`;
